import ViewController from "core/views/view.controller";
import Moment from "moment/moment";
import {Item, Items} from "core/model/items.model";

export default class NewBookingDateCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$ionicHistory', 'Bookings', 'Workloads'];

    constructor() {
        super(...arguments);

        this.booking = null;
        this.month = null;
        this.weekItems = null;
        this.workloads = {};
    }

    $onViewBeforeEnter() {
        this.loadBookingState();

        this.findFreeDates().then((dates)=> {
            this.weekItems = this.createWeekItems(dates, this.booking.date);
        });

        this.loadWorkloads();
    }

    findFreeDates() {
        return this.loadFreeDates().then((dates)=> {
            var foundFreeDate = dates.find(date => !date.disabled) != null;

            if (foundFreeDate) {
                return dates;
            } else {
                this.month = this.month.add(1, 'month');
                return this.findFreeDates();
            }
        });
    }

    prev() {
        this.saveBookingState();
        this.$ionicHistory.goBack();
    }

    next() {
        if (!this.weekItems.hasSelected()) {
            return;
        }

        this.saveBookingState();
        this.toState('tab.new-booking-time');
    }

    selectDate(dateItem) {
        dateItem.selected = true;
        this.booking.date = dateItem.value;
        this.next();
    }

    nextMonth() {
        this.month = this.month.add(1, 'month');

        this.loadFreeDates().then((dates)=> {
            this.weekItems.merge(this.createWeekItems(dates, null));
        });

        this.loadWorkloads();
    }

    loadBookingState() {
        this.booking = this.viewState('booking');

        if (this.booking.date) {
            this.month = Moment(this.booking.date).startOf('month').startOf('day');
        } else {
            this.month = Moment().startOf('month').startOf('day');
        }
    }

    saveBookingState() {
        if (this.weekItems) {
            this.booking.date = this.weekItems.selectedValue(false, true);
        }

        this.viewState('booking', this.booking);
    }

    loadFreeDates() {
        return this.Bookings.freeDates(
            this.month.month(),
            this.month.year(),
            this.booking.services,
            this.booking.resources,
            this.booking.duration
        );
    }

    loadWorkloads() {
        var startDate = this.month.startOf('month').format('YYYY-MM-DD');
        var endDate = this.month.endOf('month').format('YYYY-MM-DD');

        this.Workloads.inDateRange(startDate, endDate).then((workloads)=> {
            workloads.forEach((workload)=> {
                this.workloads[workload.date] = workload;

                if (workload.percentage >= 90) {
                    workload.color = 'assertive';
                } else if (workload.percentage >= 60) {
                    workload.color = 'energized';
                } else {
                    workload.color = 'positive';
                }
            })
        });
    }

    createWeekItems(datesData, selectedDate) {
        var currentDate = Moment().startOf('day');
        var items = new Items();
        items.singleSelection = true;

        datesData.forEach((dateData)=> {
            var date = Moment(dateData.value);
            if (date.isSameOrAfter(currentDate) && !dateData.disabled) {
                var week = date.week();
                var weekItem = items.findFirstBy(week);
                if (!weekItem) {
                    weekItem = items.add(new Item(dateData.value));
                }

                var dateItem = weekItem.add(new Item(dateData.value));
                dateItem.disabled = dateData.disabled;
            }
        });

        if (selectedDate) {
            items.selectBy(selectedDate);
        }

        return items;
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-date/new-booking-date.controller.js